<template>
  <svg v-if="color_1"
       width="20"
       height="21"
       viewBox="0 0 20 21"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 1.6C1 1.44087 1.06321 1.28826 1.17574 1.17574C1.28826 1.06321 1.44087 1 1.6 1H18.4C18.5591 1 18.7117 1.06321 18.8243 1.17574C18.9368 1.28826 19 1.44087 19 1.6V15.4C19 15.4788 18.9845 15.5568 18.9543 15.6296C18.9242 15.7024 18.88 15.7685 18.8243 15.8243C18.7685 15.88 18.7024 15.9242 18.6296 15.9543C18.5568 15.9845 18.4788 16 18.4 16H14.26C14.1779 15.9999 14.0967 16.0166 14.0214 16.0491C13.9461 16.0816 13.8782 16.1292 13.822 16.189L10.437 19.786C10.3809 19.8456 10.3132 19.8931 10.238 19.9256C10.1629 19.9581 10.0819 19.9749 10 19.9749C9.91813 19.9749 9.83712 19.9581 9.76197 19.9256C9.68681 19.8931 9.6191 19.8456 9.563 19.786L6.178 16.189C6.1218 16.1292 6.05393 16.0816 5.97859 16.0491C5.90325 16.0166 5.82205 15.9999 5.74 16H1.6C1.44087 16 1.28826 15.9368 1.17574 15.8243C1.06321 15.7117 1 15.5591 1 15.4V1.6Z"
      stroke="url(#ai_suggested_gradient)"
      stroke-width="1.5" />
    <path
      d="M10 5L11.425 7.575L14 9L11.425 10.425L10 13L8.575 10.425L6 9L8.575 7.575L10 5Z"
      stroke="url(#ai_suggested_gradient)"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />

    <defs>
      <linearGradient id="ai_suggested_gradient"
                      x1="10"
                      y1="6"
                      x2="10"
                      y2="21.766"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="color_1" />
        <stop offset="1" :stop-color="color_2" />
      </linearGradient>
      <linearGradient id="ai_suggested_gradient"
                      x1="14"
                      y1="2"
                      x2="14"
                      y2="14"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="color_1" />
        <stop offset="1" :stop-color="color_2" />
      </linearGradient>
    </defs>
  </svg>

  <svg v-else
       width="20"
       height="21"
       viewBox="0 0 20 21"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 1.6C1 1.44087 1.06321 1.28826 1.17574 1.17574C1.28826 1.06321 1.44087 1 1.6 1H18.4C18.5591 1 18.7117 1.06321 18.8243 1.17574C18.9368 1.28826 19 1.44087 19 1.6V15.4C19 15.4788 18.9845 15.5568 18.9543 15.6296C18.9242 15.7024 18.88 15.7685 18.8243 15.8243C18.7685 15.88 18.7024 15.9242 18.6296 15.9543C18.5568 15.9845 18.4788 16 18.4 16H14.26C14.1779 15.9999 14.0967 16.0166 14.0214 16.0491C13.9461 16.0816 13.8782 16.1292 13.822 16.189L10.437 19.786C10.3809 19.8456 10.3132 19.8931 10.238 19.9256C10.1629 19.9581 10.0819 19.9749 10 19.9749C9.91813 19.9749 9.83712 19.9581 9.76197 19.9256C9.68681 19.8931 9.6191 19.8456 9.563 19.786L6.178 16.189C6.1218 16.1292 6.05393 16.0816 5.97859 16.0491C5.90325 16.0166 5.82205 15.9999 5.74 16H1.6C1.44087 16 1.28826 15.9368 1.17574 15.8243C1.06321 15.7117 1 15.5591 1 15.4V1.6Z"
      :stroke="color"
      stroke-width="1.5" />
    <path
      d="M10 5L11.425 7.575L14 9L11.425 10.425L10 13L8.575 10.425L6 9L8.575 7.575L10 5Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#899399"
    },
    color_1: null,
    color_2: null
  }
}
</script>
